import type { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';

import { usePermissions } from '@/auth/usePermissions';

/**
 * Plane-aware landing (PTV2-1383). A global platform admin carries `platform:*` but no tenant
 * access (the two planes are disjoint), so sending everyone to `/browse/patients` lands them on a
 * clinical page they can't use ("forbidden" content). Route a pure global admin to the global
 * cluster admin console instead; everyone else keeps the patient-browse landing.
 */
export function HomeRedirect(): ReactElement {
  const { canOpenPlatform } = usePermissions();
  // platform:* is exclusive to global-plane roles (PLATFORM_ADMIN / TENANT_OPERATOR / VIEWER); a
  // tenant user never has it. NB a PLATFORM_ADMIN also carries admin:*/tenant:* per the ABAC policy,
  // so we must key off platform access — not the ABSENCE of tenant perms — to detect a global admin.
  if (canOpenPlatform) {
    return <Navigate to="/platform" replace />;
  }
  return <Navigate to="/browse/patients" replace />;
}
